<template>
    <div>
        <!-- Filters -->
        <b-card no-body>
            <b-card-body>
                <b-row>
                    <b-col cols="6" md="3">
                        <label for="document_id">
                            Document Name <small class="text-danger" v-if="serverErrors && serverErrors.document_id">{{ serverErrors.document_id[0] }}</small>
                        </label>
                        <b-form-select
                            id="document_id"
                            name="document_id"
                            size="sm"
                            v-model="document_id"
                        >
                            <b-form-select-option :value="null">Select...</b-form-select-option>
                            <b-form-select-option
                                v-for="document in documents"
                                :key="document.id"
                                :value="document.id"
                            >
                                {{ document.title }}
                            </b-form-select-option>
                        </b-form-select>
                    </b-col>
                    <b-col cols="6" md="2">
                        <label for="number">
                            Shipment Number <small class="text-danger" v-if="serverErrors && serverErrors.number">{{ serverErrors.number[0] }}</small>
                        </label>
                        <b-form-input
                            id="number"
                            name="number"
                            size="sm"
                            v-model="number"
                        />
                    </b-col>
                    <b-col cols="6" md="2" class="pt-2">
                        <b-button
                            variant="outline-success"
                            size="sm"
                            @click="generateReport()"
                        >
                            <b-spinner small class="mr-1" label="Small Spinner" v-if="saving" />
                            <span class="text-nowrap">Generate</span>
                            <feather-icon icon="DownloadCloudIcon" class="ml-1"/>
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <!-- ./Filters -->

        <b-row>
            <b-col cols="12" md="6">
                <b-card no-body class="mb-0">
                    <div class="m-2">
                        <!-- Table Top -->
                        <b-row>
                            <!-- Search & Button -->
                            <b-col cols="12" md="6">
                                <div class="d-flex align-items-center justify-content-start">
                                    <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..."
                                        size="sm" />
                                </div>
                            </b-col>
                            <!-- ./Search & Button-->
                        </b-row>
                        <!-- ./Table Top -->
                    </div>

                    <!-- Table -->
                    <b-table
                        striped
                        hover
                        small
                        ref="records"
                        class="position-relative"
                        :items="drafts"
                        responsive
                        :fields="columns"
                        primary-key="id"
                        show-empty
                        empty-text="No records found"
                    >
                        <template #head(id)>
                            <div style="display: flex; align-items: center; justify-content: center">

                                <b-form-checkbox
                                    :checked="draft.reports.length === drafts.length"
                                    class="custom-control-danger"
                                    @change="toggleAllOnPage"
                                >
                                </b-form-checkbox>
                            </div>
                        </template>
                        
                        <template #cell(id)="data">
                            <div style="display: flex; align-items: center; justify-content: center">
                                <b-form-checkbox
                                    v-model="draft.reports"
                                    :value="data.item.id"
                                    :checked="draft.reports.includes(data.item.id)"
                                    class="custom-control-info"
                                >
                                </b-form-checkbox>
                            </div>
                        </template>

                        <template #head(title)>
                            <span style="cursor:pointer;" @click="toggleAllOnPage">Attachment Name</span>
                        </template>

                        <template #cell(title)="data">
                            <span style="cursor:pointer;" @click="toggleRow(data.item)">{{ data.item.title }}</span>
                        </template>
                    </b-table>

                    <!-- Table Footer -->
                    <div class="mx-2 mb-2">
                        <b-row>
                             <b-col
                                cols="6"
                                class="d-flex align-items-center justify-content-start justify-content-sm-start"
                            >
                                <b-row>
                                    <b-col cols="12" class="d-flex align-items-center">
                                        <b-form-group label-for="shipment_number" label="Shipment Number" class="mr-1">
                                            <b-form-input
                                                id="shipment_number"
                                                name="shipment_number"
                                                size="sm"
                                                v-model="draft.number"
                                            />
                                        </b-form-group>

                                        <b-button
                                            size="sm"
                                            variant="outline-info"
                                            @click="generateDrafts()"
                                            :disabled="creating"
                                        >
                                            <b-spinner small class="mr-1" label="Small Spinner" v-if="creating" />
                                            <span v-if="!creating">Generate</span>
                                            <span v-if="creating">Generating...</span>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="6">
                                <small class="text-danger">{{ creatingError }}</small>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import {
        BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
        BForm, BFormGroup,
        BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem, BFormDatepicker, BFormCheckbox,
        BSpinner, BBadge,
    } from 'bootstrap-vue'

    import store from '@/store'
    import { ref, onUnmounted, onMounted } from '@vue/composition-api'
    import vSelect from 'vue-select'
    import attachmentsStoreModule from '@/views/cromis/reports/attachments/attachmentsStoreModule'
    import axios from '@axios'
import { debounce } from 'lodash'
    
    export default {
        props: {},
        components: {
            BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
            BForm, BFormGroup,
            BButton, BFormSelect, BFormSelectOption, BFormInput, vSelect, BDropdown, BDropdownItem, BFormDatepicker, BFormCheckbox,
            BSpinner, BBadge,
            ValidationObserver, ValidationProvider,
        },
        directives: {},

        setup(props, context){
            const dataForm = ref(null)
            const myModal = ref(null)
            const saving = ref(false)
            const creating = ref(false)
            const creatingError = ref(null)
            const serverErrors = ref({
                document_id: null,
                number: null,
            })

            const documents = ref([])
            const document_id = ref(null)
            const number = ref(null)

            const searchQuery = ref(null)
            const columns = ref([
                { key: 'id', label: '', sortable: false, thStyle: 'width:36px; min-width:36px' },
                { key: 'title', label: 'Attachment Name', sortable: false },
            ])
            const drafts = ref([])
            const draft = ref({
                report_id: null,
                number: number,
                reports: [],
            })

            const CROMIS_STORE_MODULE_NAME = 'cromis-attachment'

            // Register module
            if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, attachmentsStoreModule)

            // UnRegister on leave
            onUnmounted(() => {
                if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
            })

            onMounted(async () => {
                getInnerMenus(JSON.parse(localStorage.getItem('userData')).menus, context.root.$router.currentRoute.name)
            })

            const getInnerMenus = (menus, currentMenu) => {

                menus.map((menu) => {
                    if(menu.children.length > 0)
                        getInnerMenus(menu.children, currentMenu)

                    if(menu.webRoute && menu.webRoute.localeCompare(currentMenu) === 0  && menu.id !== 108){
                        documents.value = menu.children
                    }
                    else {
                        if(menu.id === 108){
                            draft.value.report_id = menu.id
                            drafts.value = menu.children
                        }
                    }
                })
            }

            const toggleRow = item => {
                const idx = draft.value.reports.indexOf(item.id)
                if (idx > -1) draft.value.reports.splice(idx, 1)
                else draft.value.reports.push(item.id)
            }

            const toggleAllOnPage = () => {
                if (draft.value.reports.length === drafts.value.length) {
                    draft.value.reports.splice(0)
                    return
                }
                else{
                    drafts.value.forEach((el) => {
                        if(!draft.value.reports.includes(el.id)){
                            draft.value.reports.push(el.id)
                        }
                    })
                }
            }

            const generateDrafts = async () => {
                console.log('Hey 1', !draft.value.number, draft.value.reports.length)
                if(!draft.value.number === null || draft.value.reports.length === 0){
                    creatingError.value = 'Provide shipment number and then select at least one draft attachment'
                    await debounce((event) => {
                        console.log('Hello..........')
                    }, 3000)

                    creatingError.value = null

                    return
                }
                else{
                    console.log('Hey 2')
                    creating.value = true
                    store.dispatch(`${CROMIS_STORE_MODULE_NAME}/generateDrafts`, draft.value)
                        .then(response => {
                            creating.value = false
                            draft.value.number = null
                            draft.value.reports.splice(0)
                        })
                        .catch(error => {
                            creating.value = false
                            console.log(error)
                        })
                }
            }

            const generateReport = async () => {
                let hasError = false
                serverErrors.value = {
                    document_id: null,
                    number: null,
                }

                if(!document_id.value){
                    hasError = true
                    serverErrors.value.document_id = ['Specify document name']
                }

                if(!number.value){
                    hasError = true
                    serverErrors.value.number = ['Shipment number required']
                }

                if(!hasError){
                    saving.value = true

                    // await store.dispatch('cromis-attachment/generate', { documents: [document_id.value], number: number.value, recipients: [] })
                    //     .then(response => {
                    //         saving.value = false
                            
                    //     })
                    //     .catch(error => {
                    //         console.log('got error', error)
                    //     })
                    window.open(`${ axios.defaults.baseURL }/reports/attachments?report_id=${ document_id.value }&number=${ number.value }`, '_blank')
                    saving.value = false
                }
            }

            return {
                dataForm,
                myModal,
                saving,
                creating,
                serverErrors,
                documents,
                document_id,
                number,
                generateReport,
                searchQuery,
                columns,
                drafts,
                draft,
                toggleRow,
                toggleAllOnPage,
                creatingError,
                generateDrafts,
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>